<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="店铺分类">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="class-list">
                <flex-line v-for="item in storeclass_list" :is-link="true" :show-border="true" v-bind:key="item.storeclass_id" @click.native="goHomeStorelist(item.storeclass_id)">
                    {{item.storeclass_name}}
                </flex-line>
        </div>
        <empty-record v-if="storeclass_list && !storeclass_list.length"></empty-record>
    </div>
</template>

<script>
import { getStoreClass } from '../../../api/seller'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  components: {
      flexLine,
    EmptyRecord
  },
  name: 'Storeclass',
  data () {
    return {
      storeclass_list: false
    }
  },
  created: function () {
    this.getStoreclassList()
  },
  methods: {
    getStoreclassList () {
      Indicator.open()
        getStoreClass().then(res => {
        Indicator.close()
        this.storeclass_list = res.result.store_class
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    goHomeStorelist (storeclassId) {
      this.$router.push({ name: 'HomeStorelist', query: { storeclass_id: storeclassId } })
    }
  }
}
</script>

<style scoped lang="scss">
.class-list{padding:0 $pageSpace;background: #fff}
</style>
